import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const whiskeyConfig: ServicePageConfig = {
  title: 'Whiskey - Bespoke Shopping | FGA Prestige',
  description: 'Collecting rare and vintage whiskeys from renowned distilleries worldwide through our bespoke shopping service.',
  slug: 'bespoke-shopping/whiskey',
  heroImage: '/Bespoke Shopping/Retail Partners/WHISKEY/hero.png',
  serviceName: 'WHISKEY',
  whySectionA: {
    title: 'Curating the Pinnacle of Whisky Luxury',
    content: 'From rarefied Scottish single malts to cult-status Japanese blends, today’s top whiskies deliver more than exquisite flavor—they heritage, scarcity and investment-grade allure. Global demand for ultra-aged expressions now fuels a luxury-whisky market forecast to crest US $21 billion by 2033, compounding at roughly 5% a year. In other words: liquid gold has never looked richer.',
    image: '/Bespoke Shopping/Retail Partners/WHISKEY/body/1.png',
    imageAlt: 'Whiskey Expert Authentication'
  },
  whySectionC: {
    title: 'Icons of the Cask',
    content: 'The Macallan remains the category\'s crown jewel. A single bottle of 1926 Adami shattered auction records at US $2.7 million in late 2023, underscoring just how ferociously collectors chase Speyside\'s finest. Yamazaki continues Japan\'s rise; the 55-year sold for HK$2.5 million this summer, reaffirming its status as Asia\'s ultimate trophy dram.',
    image: '/Bespoke Shopping/Retail Partners/WHISKEY/body/2.png',
    imageAlt: 'Whiskey Expert Authentication'
  },
  whySectionB: {
    title: 'Experience Beyond the Bottle',
    benefits: [
      {
        title: '',
        description: 'We orchestrate private cask selections at Speyside estates, fly-in tastings of Yamazaki\'s unreleased sherry puncheons, and bespoke decanter commissions that rival any objet d\'art. Provenance is verified down to the warehouse floor; storage occurs in climate-insured vaults from London to Hong Kong.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/WHISKEY/body/3.png',
    imageAlt: 'Premium whiskey collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/WHISKEY/CTA_Banner/banner.png'
}

const WhiskeyPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Whiskey - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Collecting rare and vintage whiskeys from renowned distilleries worldwide through our bespoke shopping service." />
        <meta property="og:title" content="Whiskey - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Collecting rare and vintage whiskeys from renowned distilleries worldwide through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/whiskey" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/WHISKEY/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Premium Whiskey" />
      </Helmet>
      
      <ServicePageTemplate config={whiskeyConfig} />
    </>
  )
}

export default WhiskeyPage